import { combineReducers } from 'redux';

import collectEmailAddressReducerMap, {
    collectEmailAddressAction,
} from './actions/collectEmailAddress';
import fetchCarrierContactReducerMap, {
    fetchCarrierContactAction,
} from './actions/fetchCarrierContact';
import fetchCarrierGuideReducerMap, {
    fetchCarrierGuideAction,
} from './actions/fetchCarrierGuide';
import fetchCityGuideReducerMap, {
    fetchCityGuideAction,
} from './actions/fetchCityGuide';
import fetchCityToCityReducerMap, {
    fetchCityToCityAction,
} from './actions/fetchCityToCityData';
import fetchCountryGuideReducerMap, {
    fetchCountryGuideAction,
} from './actions/fetchCountryGuide';
import fetchIndexGuideReducerMap, {
    fetchIndexGuideAction,
} from './actions/fetchIndexGuide';
import fetchNewRoutesReducerMap, {
    fetchNewRoutesAction,
} from './actions/fetchNewRoutes';
import fetchReviewFeedReducerMap, {
    fetchReviewFeedAction,
} from './actions/fetchReviewFeed';
import fetchScheduleReducerMap, {
    fetchScheduleAction,
} from './actions/fetchSchedule';
import fetchStateGuideReducerMap, {
    fetchStateGuideAction,
} from './actions/fetchStateGuide';
import carrierContactReducerMap, {
    selectors as carrierContactSelectors,
} from './appstate/carrierContact';
import carrierGuideReducerMap, {
    selectors as carrierGuideSelectors,
    shapes as carrierGuideShapes,
} from './appstate/carrierGuide';
import cityToCityReducerMap, {
    selectors as cityToCitySelectors,
    actions as cityToCityActions,
} from './appstate/cityToCity';
import newRoutesReducerMap, {
    selectors as newRoutesSelectors,
} from './appstate/newRoutes';
import placeGuideReducerMap, {
    selectors as placeGuideSelectors,
} from './appstate/placeGuide';
import reviewFeedReducerMap, {
    selectors as reviewFeedSelectors,
} from './appstate/reviewFeed';
import scheduleReducerMap, {
    selectors as scheduleSelectors,
    actions as scheduleActions,
} from './appstate/schedule';
import {
    TOC_NAV_ITEMS as C2C_NAV_ITEMS,
} from './data/c2cTemplateConstants';
import {
    TOC_NAV_ITEMS as CG_NAV_ITEMS,
    POLICY_CONTENT as CG_POLICY_CONTENT,
    CARRIER_CONTENT as CG_CARRIER_CONTENT,
} from './data/carrierGuideTemplateConstants';
import {
    TOC_NAV_ITEMS as CITY_NAV_ITEMS,
    COUNTRY_GUIDE_CONTENT,
} from './data/placeGuideTemplateConstants';
import namespace from './types';
import { mapInfoSectionContent, mapCarrierData } from './utils';

const reducer = combineReducers({
    ...collectEmailAddressReducerMap,
    ...fetchCarrierContactReducerMap,
    ...fetchCarrierGuideReducerMap,
    ...fetchCityGuideReducerMap,
    ...fetchCityToCityReducerMap,
    ...fetchStateGuideReducerMap,
    ...fetchCountryGuideReducerMap,
    ...fetchIndexGuideReducerMap,
    ...fetchReviewFeedReducerMap,
    ...fetchNewRoutesReducerMap,
    ...fetchScheduleReducerMap,
    ...carrierContactReducerMap,
    ...carrierGuideReducerMap,
    ...placeGuideReducerMap,
    ...cityToCityReducerMap,
    ...reviewFeedReducerMap,
    ...newRoutesReducerMap,
    ...scheduleReducerMap,
});

export {
    C2C_NAV_ITEMS,
    CG_CARRIER_CONTENT,
    CG_NAV_ITEMS,
    CG_POLICY_CONTENT,
    CITY_NAV_ITEMS,
    COUNTRY_GUIDE_CONTENT,
    carrierContactSelectors,
    carrierGuideSelectors,
    carrierGuideShapes,
    cityToCityActions,
    cityToCitySelectors,

    collectEmailAddressAction,
    fetchCarrierContactAction,
    fetchCarrierGuideAction,
    fetchCityGuideAction,
    fetchCityToCityAction,
    fetchCountryGuideAction,

    fetchIndexGuideAction,
    fetchNewRoutesAction,
    fetchReviewFeedAction,
    fetchScheduleAction,
    fetchStateGuideAction,
    mapCarrierData,
    mapInfoSectionContent,
    newRoutesSelectors,
    placeGuideSelectors,
    reviewFeedSelectors,
    scheduleActions,
    scheduleSelectors,
};

export default {
    [namespace]: reducer,
};
